import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularDelisting: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_delisting"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="delisting icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 5C3.00736 5 2 6.00736 2 7.25V16.75C2 17.9926 3.00736 19 4.25 19H19.75C20.9926 19 22 17.9926 22 16.75V7.25C22 6.00736 20.9926 5 19.75 5H4.25ZM3.5 7.25C3.5 6.83579 3.83579 6.5 4.25 6.5H19.75C20.1642 6.5 20.5 6.83579 20.5 7.25V9.5H3.5V7.25ZM3.5 11V16.75C3.5 17.1642 3.83579 17.5 4.25 17.5H19.75C20.1642 17.5 20.5 17.1642 20.5 16.75V11H3.5Z"
        />
      </svg>
    </span>
  );
};

export { RegularDelisting };
